import {authGuard} from '@common/auth/guards/auth-route';
import {shouldRevalidateDatatableLoader} from '@common/datatable/filters/utils/should-revalidate-datatable-loader';
import {RouteObject} from 'react-router';

export const adminApprovalsRoutes: Record<string, RouteObject> = {
  index: {
    path: 'approvals',
    lazy: () => import('@app/admin/approvals/approvals-datatable'),
    shouldRevalidate: shouldRevalidateDatatableLoader,
    // shared tab: super admins decide, requesters track their own; the
    // backend scopes what each role sees
    loader: () => authGuard({permission: 'admin.access'}),
  },
};
